"use client";
import type { ReactElement, RefObject } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FontWeight } from "@/theme/typography";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
import { TOOLTIP_BACKGROUND, TOOLTIP_BORDER } from "./timeline-constants";
import type { HoveredEventTooltip } from "./timeline-root-types";
import type { TimelineTooltipPosition } from "./timeline-tooltip-position";
const TOOLTIP_MAX_WIDTH = 280;
const TOOLTIP_BORDER_RADIUS = 10;
const TOOLTIP_PADDING = "8px 10px";
const TOOLTIP_FONT_SIZE = 12;
const TOOLTIP_LINE_HEIGHT = "16px";
export interface TimelineTooltipProps {
    tooltip: HoveredEventTooltip | null;
    tooltipPosition: TimelineTooltipPosition | null;
    tooltipRef: RefObject<HTMLDivElement | null>;
}
export function TimelineTooltip({ tooltip, tooltipPosition, tooltipRef, }: TimelineTooltipProps): ReactElement {
    return (<AnimatePresence>
      {tooltip && tooltipPosition && (
          <motion.div data-el="Cmarkdowntimeline/TimelineTooltip/Root" key={`timeline-tooltip-${tooltip.key}`} ref={tooltipRef} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 4 }} transition={{ duration: 0.16, ease: "easeOut" }} style={{
                position: "absolute",
                left: tooltipPosition.left,
                top: tooltipPosition.top,
                pointerEvents: "none",
                maxWidth: TOOLTIP_MAX_WIDTH,
                backgroundColor: TOOLTIP_BACKGROUND,
                border: TOOLTIP_BORDER,
                borderRadius: TOOLTIP_BORDER_RADIUS,
                padding: TOOLTIP_PADDING,
                fontSize: TOOLTIP_FONT_SIZE,
                lineHeight: TOOLTIP_LINE_HEIGHT,
                color: "rgba(255,255,255,0.86)",
                zIndex: 40,
                boxShadow: "0 12px 24px -14px rgba(0,0,0,0.7)",
            }}>
            <CmarkdownLabelText dataElScope="Cmarkdowntimeline/TimelineTooltip" content={tooltip.text} size={TOOLTIP_FONT_SIZE} weight={FontWeight.Regular} paragraphStyle={{ marginBottom: 0 }} textStyle={{ color: "inherit", lineHeight: TOOLTIP_LINE_HEIGHT }}/>
          </motion.div>
        )}
    </AnimatePresence>);
}
